import React from "react";
import { motion, useScroll } from "framer-motion";
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  return <motion.div aria-hidden="true" className="fixed inset-x-0 top-0 z-[60] h-[2px] origin-left bg-gold" style={{
    scaleX: scrollYProgress
  }} data-id="element-353" data-mp="3iwt4solww0x5" />;
}